module.exports = __webpack_public_path__ + "img/clogo.abff8a50.png";